import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
// Keep full Vuetify styles in the initial CSS bundle (production extract).
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

// Use SVG icons (bundled paths) instead of the MDI webfont CDN.
// CDN fonts (jsDelivr / Google) are often unreachable in this environment,
// which leaves only empty ::after rules and missing ::before glyphs.
export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
    values: {
      // App-specific icons used as $finance / $apps / $eye / $powerStandby / $calendar
      finance:
        'M6,16.5L3,19.44V11H6M11,14.66L9.43,13.32L8,14.64V7H11M16,13L13,16V3H16M18.81,12.81L17,11V17H22V15.5C22,13.56 20.22,12.18 18.81,12.81Z',
      apps:
        'M16,20H20V16H16M16,14H20V10H16M10,8H14V4H10M16,8H20V4H16M10,14H14V10H10M4,14H8V10H4M4,20H8V16H4M10,20H14V16H10M4,8H8V4H4V8Z',
      eye:
        'M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z',
      powerStandby:
        'M13,3H11V13H13V3M17.83,5.17L16.41,6.59C17.99,7.86 19,9.81 19,12C19,15.87 15.87,19 12,19C8.13,19 5,15.87 5,12C5,9.81 6.01,7.86 7.58,6.58L6.17,5.17C4.23,6.82 3,9.26 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,9.26 19.77,6.82 17.83,5.17Z',
      calendar:
        'M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z',
    },
  },
})
